import { render, staticRenderFns } from "./RequestBuyPage.vue?vue&type=template&id=753be03c&scoped=true"
import script from "./RequestBuyPage.vue?vue&type=script&lang=ts"
export * from "./RequestBuyPage.vue?vue&type=script&lang=ts"
import style0 from "./RequestBuyPage.vue?vue&type=style&index=0&id=753be03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753be03c",
  null
  
)

export default component.exports